import React, {useState} from "react";
import styled from "styled-components";
import { Button } from "semantic-ui-react";

const StyledTable = styled.table`
  font-size: 20px;
  caption-side: top;
  border: none;
  margin: auto;
  padding-bottom: 20px;
  border-collapse: collapse;
  /* border-collapse: separate; */
  /* border-spacing: 5px 10px; */

  caption-side: bottom;
  /* empty-cell: show | hide;  */
  /* empty-cell is a property of table or the cells themselves */

  /* vertical-align: baseline | sub | super | text-top | 
                text-bottom | middle | top | bottom | 
                <percentage> | <length> */

  /* tbody {
    vertical-align: top;
  }              */
  td,
  th {
    border: none;
  }
  /* td,
  th {
    border: 1px solid;
  } */

  td {
    padding: 5px 10px;
  }

  tbody tr {
    :nth-of-type(odd) {
      background-color: #efefef;
    }
  }
  thead > tr {
    background-color: #c2c2c2;
  }
  caption {
    font-size: 0.9em;
    padding: 5px;
    font-weight: bold;
  }
  background-color: lightgray;
  @media screen and (max-width: 500px)
        {
          font-size: 4.5vw;
        }
`;
// eslint-disable-next-line import/no-anonymous-default-export
export default ({ data, state, tt_route_id }) => (
  <TableMarkup titles={Object.keys(data[0])} data={data} state={state} tt_route_id={tt_route_id} />
);
const TableMarkup = ({ titles, data, tt_route_id }) => (
  <StyledTable>
    <colgroup>
      <col />
      <col />
      <col />
    </colgroup>
    <thead>
      <tr>
        {titles.map((title, index) => (
          <th key={index}>{title}</th>
        ))}
      </tr>
    </thead>
    <tbody>
      {data.map((item, index) => (
        <tr key={index}>
          {titles.map((title, index) => (
            <td key={index}>{item[title]}</td>
          ))}
        </tr>
      ))}
    </tbody>
    <tfoot>{`\u2001`}</tfoot>
  </StyledTable>
);
